import React from 'react';
import { useLocation } from 'react-router-dom';
import useBreadcrumbs from '../../../utility/routing/useBreadcrumbs';
import { useCarousels } from './hooks/useCarousels';
import { CarouselGrid } from './components/CarouselGrid';

/**
 * Page that lists the front page carousels
 * @returns Page component
 */
const LookupCarousel: React.FC = () => {
  const location = useLocation();
  
  useBreadcrumbs([
    {
      id: 0,
      name: 'Dashboard',
      path: '/admin/dashboard'
    },
    {
      id: 5,
      name: 'Landing',
      path: location.pathname
    }
  ]);
  
  const { curCarousels, setCurCarousels, submitCarouselChanges, refetch } = useCarousels();

  return (
    <div style={{ display: 'grid', gridTemplateRows: '1fr' }}>
      <CarouselGrid
        curCarousels={curCarousels}
        setCurCarousels={setCurCarousels}
        submit={submitCarouselChanges}
        refetch={refetch}
      />
    </div>
  );
};

export default LookupCarousel;
